import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '@/theme/brand';

const BrandLogo = ({
  to = '/',
  showTagline = true,
  size = 'md',
  className = '',
  asLink = true,
}) => {
  const sizes = {
    sm: { img: 'h-10', title: 'text-lg', tag: 'text-[0.55rem]' },
    md: { img: 'h-14', title: 'text-2xl', tag: 'text-[0.65rem]' },
    lg: { img: 'h-20', title: 'text-3xl', tag: 'text-xs' },
  };
  const s = sizes[size] || sizes.md;

  const content = (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="brand-logo-mark inline-flex overflow-hidden leading-none">
        <img
          src={BRAND.logoSrc}
          alt={`${BRAND.name} ${BRAND.tagline}`}
          className={`${s.img} w-auto object-contain`}
        />
      </span>
      {showTagline && (
        <div className="hidden sm:block leading-tight">
          <span className="brand-wordmark text-atithi-navy block uppercase">
            {BRAND.name}
          </span>
          <span className={`${s.tag} font-body font-semibold tracking-[0.2em] text-atithi-saffron uppercase`}>
            {BRAND.tagline}
          </span>
        </div>
      )}
    </div>
  );

  if (!asLink) return content;

  return (
    <Link to={to} className="hover:opacity-90 transition-opacity" data-testid="brand-logo">
      {content}
    </Link>
  );
};

export default BrandLogo;
